/* istanbul ignore file */
/**
 * Accordion component theme configuration.
 */

export const accordionComponentConfig = {
  accordion: {
    root: {
      transitionDuration: '{transition.duration}',
    },
    panel: {
      borderWidth: '0',
      borderColor: '{content.border.color}',
    },
    header: {
      background: '{content.background}',
      hoverBackground: '{content.hover.background}',
      activeBackground: '{content.background}',
      activeHoverBackground: '{content.hover.background}',
      color: '{text.color}',
      hoverColor: '{text.color}',
      activeColor: '{text.color}',
      padding: '1.125rem',
      fontWeight: 'unset',
      borderRadius: '0',
      borderWidth: '0 0 1px 0',
      borderColor: '{content.border.color}',
      focusRing: {
        width: '{focus.ring.width}',
        style: '{focus.ring.style}',
        color: '{focus.ring.color}',
        offset: '-2px',
        shadow: '{focus.ring.shadow}',
      },
      toggleIcon: {
        color: '{text.color}',
        hoverColor: '{text.color}',
        activeColor: '{text.color}',
        activeHoverColor: '{text.color}',
      },
      first: {
        topBorderRadius: '{content.borderRadius}',
        borderWidth: '0',
      },
      last: {
        bottomBorderRadius: '{content.borderRadius}',
        activeBottomBorderRadius: '0',
      },
    },
    content: {
      borderWidth: '0',
      background: '{content.background}',
      color: '{text.color}',
      padding: '1.125rem',
    },
  },
};
